import { TTypeOfCodec } from "../../../shared/src/codecs/codec";
import { formIO, TFormIOCodec } from "../../../shared/src/codecs/types/formIO";
import { required, TRequiredCodec } from "../../../shared/src/codecs/types/required";
import { uuid, TUuidCodec } from "../../../shared/src/codecs/types/uuid";
import { integer, TIntegerCodec } from "../../../shared/src/codecs/types/integer";
import { boolean, TBooleanCodec } from "../../../shared/src/codecs/types/boolean";

type TGetUserDeletionBlockersInputCodec = TRequiredCodec<{
    user_id: TUuidCodec;
}>;

type TGetUserDeletionBlockersOutputCodec = TRequiredCodec<{
    open_cases_as_handler: TIntegerCodec;
    open_cases_as_supervisor: TIntegerCodec;
    open_ad_hoc_jobs: TIntegerCodec;
    unresolved_emails: TIntegerCodec;
    open_roadblocks: TIntegerCodec;
    unresolvable_roadblocks: TIntegerCodec;
    delegated_inbox_owner_count: TIntegerCodec;
    is_only_fallback_roadblocks_assignee: TBooleanCodec;
    is_only_sign_off_authoriser: TBooleanCodec;
    is_only_mlro: TBooleanCodec;
}>;

export const GetUserDeletionBlockersFormIO: TFormIOCodec<
    TGetUserDeletionBlockersInputCodec,
    TGetUserDeletionBlockersOutputCodec
> = formIO(
    required({
        user_id: uuid(),
    }),
    required({
        open_cases_as_handler: integer(),
        open_cases_as_supervisor: integer(),
        open_ad_hoc_jobs: integer(),
        unresolved_emails: integer(),
        open_roadblocks: integer(),
        unresolvable_roadblocks: integer(),
        delegated_inbox_owner_count: integer(),
        is_only_fallback_roadblocks_assignee: boolean(),
        is_only_sign_off_authoriser: boolean(),
        is_only_mlro: boolean(),
    }),
);

export type TGetUserDeletionBlockersFormIOCodec = typeof GetUserDeletionBlockersFormIO;
export type TGetUserDeletionBlockersFormIO = TTypeOfCodec<TGetUserDeletionBlockersFormIOCodec>;
